import React, { useContext, useRef } from "react";
import { OwcMenu, OwcListItem } from "@one/react";
import { entryType, MyLabMenuArray } from "../../constants";
import { EquipmentsContext } from "./equipments-context/context";
import { getFieldValue } from "@digitallab/grid-common-components";
// import { setCookieData } from "../../utils/helpers/cookie";
const MyEquipmentMenu = ({
  params,
  setShowMenu,
  removeMyLabEquipment,
  showMyLab,
  updateMyLabEquipment,
  isEditMode
}) => {
  const menuElement = useRef(null);
  const { myLabEquipment } = useContext(EquipmentsContext);

  let paramsValue = null;
  paramsValue = getFieldValue(params?.data, "id")?.toString();

  const dataEntryType = getFieldValue(params?.data, "entry_type");
  const isBookable = getFieldValue(params?.data, "is_bookable") === "true";
  const isVisualized = getFieldValue(params?.data, "is_visualized") === "true";
  const isInMyLab = myLabEquipment.includes(paramsValue);

  const getRemoveVisibility = (baseCanShow) => {
    if (isInMyLab) {
      return true;
    }
    if (!showMyLab && isEditMode) {
      return false;
    }
    return baseCanShow;
  };

  const getItemVisibility = (item) => {
    const baseCanShow = item.availableFor.includes(dataEntryType);

    switch (item.key) {
      case "bookEquipment":
        return dataEntryType === entryType.standaloneEquipment ? isBookable : baseCanShow;
      case "bookCluster":
        return dataEntryType === entryType?.cluster ? isBookable : baseCanShow;
      case "viewMonitoring":
        return isVisualized;
      case "add":
        return baseCanShow && !isInMyLab && !showMyLab;
      case "remove":
        return getRemoveVisibility(baseCanShow);
      default:
        return baseCanShow;
    }
  };

  const redirectWithoutCookie = (inventoryId, option) => {
    let launchURL = "";
    if (option === "bookEquipment" || option === "bookCluster") {
      launchURL = `${process.env.REACT_APP_GRAPHQL_BOOKING_ENDPOINT_CLOUDFRONT}equipmentList/${inventoryId}`;
    }
    if (option === "viewLogbook") {
      launchURL = `${process.env.REACT_APP_GRAPHQL_LOGBOOK_ENDPOINT_CLOUDFRONT}cover-sheet/${inventoryId}`;
    }
    if (option === "viewMonitoring") {
      launchURL = `${process.env.REACT_APP_GRAPHQL_MONITORING_ENDPOINT_CLOUDFRONT}equipmentList/${inventoryId}`;
    }
    if (option === "viewRepo") {
      launchURL = `${process.env.REACT_APP_GRAPHQL_REPO_ENDPOINT_CLOUDFRONT}equipmentList/${inventoryId}`;
    }
    window.open(launchURL);
  };

  const handleClick = (option) => {
    setShowMenu(false);
    switch (option) {
      case "bookEquipment":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "viewLogbook":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "viewMonitoring":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "viewRepo":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "bookCluster":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "remove":
        removeMyLabEquipment(getFieldValue(params?.data, "id"));
        break;
      case "add":
        updateMyLabEquipment(getFieldValue(params?.data, "id"));
        break;
      default:
    }
  };

  return (
    <div>
      <OwcMenu
        ref={menuElement}
        visible={true}
        onClickOutside={() => setShowMenu(false)}
        anchor={getFieldValue(params?.data, "id")}
        disable-portal={true}
        strategy="fixed"
      >
        {MyLabMenuArray.map((item) => {
          const canShow = getItemVisibility(item);
          return (
            canShow && (
              <OwcListItem
                onClick={() => {
                  handleClick(item.key);
                }}
              >
                {item.value}
              </OwcListItem>
            )
          );
        })}
      </OwcMenu>
    </div>
  );
};

export default MyEquipmentMenu;
